// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__sC-8b","loaderItem":"Loader_loaderItem__37iQL"};